var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app"},[(!_vm.isNotFoundPage)?_c('app-header'):_vm._e(),_c('router-view',{staticClass:"app__content"}),(!_vm.isNotFoundPage)?_c('app-footer'):_vm._e(),(!_vm.isNotFoundPage)?_c('app-sticky-offer-link'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }